export enum SearchOption {
  OFFSET = 0,
  LIMIT = 2
}
